var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconNowPlaying = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M5.6 16h.8a.6.6 0 0 1 .6.6V25H5v-8.4a.6.6 0 0 1 .6-.6m5-8h.8a.6.6 0 0 1 .6.6V25h-2V8.6a.6.6 0 0 1 .6-.6m5 4h.8a.6.6 0 0 1 .6.6V25h-2V12.6a.6.6 0 0 1 .6-.6m5-1h.8a.6.6 0 0 1 .6.6V25h-2V11.6a.6.6 0 0 1 .6-.6m5 6h.8a.6.6 0 0 1 .6.6V25h-2v-7.4a.6.6 0 0 1 .6-.6"
})));
export default SvgIconNowPlaying;